<p class="font-bold text-lg mt-0 additional-data-heading">
  {{ 'modules.notification.alarmRuleAddEdit.additionalData' | translate }}
</p>
<div [formGroup]="form" class="additional-form-container pb-4">
  @if (isNeedSelectionType) {
    <div class="grid grid-nogutter gap-2">
      <div class="flex flex-column flex-1 gap-2 col-6">
        <osp-form-field>
          <osp-label>{{ 'modules.notification.alarmRuleAddEdit.labels.selectionType' | translate }}</osp-label>
          <osp-dropdown
            [formControlName]="controlNames.DATA_SELECTION_TYPE"
            [options]="$selectionTypesOptions()"
            [placeholder]="'modules.notification.alarmRuleAddEdit.placeholders.selectionType' | translate"
          />
          <osp-error [messages]="{ required: 'shared.validation.requiredField' | translate }" />
        </osp-form-field>
      </div>

      @if (selectedType) {
        @switch (selectedType) {
          @case (selectionTypes.LABEL) {
            <div class="flex flex-column gap-2 col-6">
              <osp-form-field>
                <osp-label>{{ 'modules.notification.alarmRuleAddEdit.labels.equipmentLabels' | translate }}</osp-label>
                <osp-select
                  [formControlName]="controlNames.DATA_LABELS"
                  [options]="$formattedLabelOptions()"
                  [placeholder]="'modules.notification.alarmRuleAddEdit.placeholders.equipmentLabels' | translate"
                  [selectedItemsConfiguration]="{
                    title: 'modules.notification.alarmRuleAddEdit.labels.equipmentLabels' | translate
                  }"
                />
                <osp-error [messages]="{ required: 'shared.validation.requiredField' | translate }" />
              </osp-form-field>
            </div>
          }
          @case (selectionTypes.EQUIPMENT_TYPE) {
            <div class="flex flex-column gap-2 col-6">
              <osp-form-field>
                <osp-label>{{ 'modules.notification.alarmRuleAddEdit.labels.equipmentTypes' | translate }}</osp-label>
                <osp-select
                  [formControlName]="controlNames.DATA_EQUIPMENT_TYPES"
                  [group]="true"
                  [options]="$equipmentTypeOptions()"
                  [placeholder]="'modules.notification.alarmRuleAddEdit.placeholders.equipmentTypes' | translate"
                  [selectedItemsConfiguration]="{
                    title: 'modules.notification.alarmRuleAddEdit.labels.equipmentTypes' | translate
                  }"
                >
                  <ng-template ospTemplate="group" let-group="group">
                    {{ group.category1Name }}
                  </ng-template>
                </osp-select>
                <osp-error [messages]="{ required: 'shared.validation.requiredField' | translate }" />
              </osp-form-field>
            </div>
          }
          @case (selectionTypes.EQUIPMENT) {
            <div class="flex flex-column gap-2 col-6">
              <osp-form-field>
                <osp-label>{{ 'modules.notification.alarmRuleAddEdit.labels.equipments' | translate }}</osp-label>
                <osp-select
                  [formControlName]="controlNames.DATA_EQUIPMENTS"
                  [options]="$formattedEquipmentOptions()"
                  [placeholder]="'modules.notification.alarmRuleAddEdit.placeholders.equipments' | translate"
                  [filterDebounceTime]="filterDebounceTime"
                  [loading]="$equipmentsLoading()"
                  [selectedItemsConfiguration]="{
                    title: 'modules.notification.alarmRuleAddEdit.labels.equipments' | translate
                  }"
                  (onFilter)="$onEquipmentFilter.emit($event.filter)"
                />
                <osp-error [messages]="{ required: 'shared.validation.requiredField' | translate }" />
              </osp-form-field>
            </div>
          }
          @case (selectionTypes.CUSTOMER) {
            <div class="flex flex-column gap-2 col-6">
              <osp-form-field>
                <osp-label>{{ 'modules.notification.alarmRuleAddEdit.labels.customer' | translate }}</osp-label>
                <osp-select
                  [formControlName]="controlNames.DATA_CUSTOMER"
                  [options]="$formattedCustomerOptions()"
                  [placeholder]="'modules.notification.alarmRuleAddEdit.placeholders.customer' | translate"
                  [filterDebounceTime]="filterDebounceTime"
                  [loading]="$customersLoading()"
                  [selectedItemsConfiguration]="{
                    title: 'modules.notification.alarmRuleAddEdit.labels.customer' | translate
                  }"
                  (onFilter)="$onCustomerFilter.emit($event.filter)"
                />
                <osp-error [messages]="{ required: 'shared.validation.requiredField' | translate }" />
              </osp-form-field>
            </div>
          }
          @case (selectionTypes.EQUIPMENT_STATUS) {
            <div class="flex flex-column gap-2 col-6">
              <osp-form-field>
                <osp-label>{{ 'modules.notification.alarmRuleAddEdit.labels.equipmentStatus' | translate }}</osp-label>
                <osp-select
                  [formControlName]="controlNames.DATA_EQUIPMENT_STATUSES"
                  [options]="$formattedEquipmentStatusesOptions()"
                  [group]="true"
                  [optionLabel]="'label'"
                  [optionValue]="'value'"
                  [placeholder]="'modules.notification.alarmRuleAddEdit.placeholders.equipmentStatus' | translate"
                  [filterDebounceTime]="filterDebounceTime"
                  [loading]="$equipmentStatusesLoading()"
                  [selectedItemsConfiguration]="{
                    title: 'modules.notification.alarmRuleAddEdit.labels.equipmentStatus' | translate
                  }"
                  [$itemTmpl]="severityItemTemplate"
                  (onFilter)="$onEquipmentStatusFilter.emit($event.filter)"
                >
                  <ng-template ospTemplate="group" let-group="group">
                    {{ group.label }}
                  </ng-template>
                  <ng-template #severityItemTemplate let-item>
                    <div class="severity-item-container">
                      <div
                        class="severity-dot"
                        [ngStyle]="{
                          'background-color': (item.category | equipmentStatusCategoryToDropdownSeverity)?.statusColor
                        }"
                      ></div>
                      <span class="severity-label">{{ item.label }}</span>
                    </div>
                  </ng-template>
                </osp-select>
                <osp-error [messages]="{ required: 'shared.validation.requiredField' | translate }" />
              </osp-form-field>
            </div>
          }
        }
      }
    </div>
  }

  <div class="flex flex-column gap-2">
    <osp-form-field>
      <osp-label>{{ 'modules.notification.alarmRuleAddEdit.labels.alarmLevel' | translate }}</osp-label>
      <osp-dropdown
        [formControlName]="controlNames.DATA_ALARM_LEVEL"
        [options]="alarmLevels"
        [placeholder]="'modules.notification.alarmRuleAddEdit.placeholders.alarmLevel' | translate"
      />
      <osp-error [messages]="{ required: 'shared.validation.requiredField' | translate }" />
    </osp-form-field>
  </div>

  <div class="flex flex-column gap-2">
    <osp-form-field>
      <osp-label>{{ 'modules.notification.alarmRuleAddEdit.labels.alarmMessage' | translate }}</osp-label>
      <osp-input-textarea
        [formControlName]="controlNames.DATA_ALARM_MESSAGE"
        [placeholder]="'modules.notification.alarmRuleAddEdit.placeholders.alarmMessage' | translate"
        [rows]="2"
      />
      <osp-error
        [messages]="{
          required: 'shared.validation.requiredField' | translate,
          maxlength: 'shared.validation.maxCharacters' | translate: { value: fieldLimit.LONG_TEXT }
        }"
      />
    </osp-form-field>
  </div>

  <div class="flex flex-column gap-2">
    <osp-form-field>
      <osp-label [tooltip]="'modules.notification.alarmRuleAddEdit.tooltip.defaultEmailRecipients' | translate">{{
        'modules.notification.alarmRuleAddEdit.labels.defaultEmailRecipients' | translate
      }}</osp-label>
      <osp-select
        [formControlName]="controlNames.DATA_DEFAULT_EMAIL_RECIPIENTS"
        [options]="(userSuggestions$ | async) ?? []"
        (onFilter)="searchRecipientEmails($event.filter)"
        [isDisabledForEditing]="true"
        [showClear]="false"
        [placeholder]="resolveDefaultRecipientsPlaceholder() | translate"
        [isAllowedToSeeData]="isAllowedToSeeDefaultRecipients"
        [selectedItemsConfiguration]="{
          title: 'modules.notification.alarmRuleAddEdit.labels.defaultEmailRecipients' | translate,
          restrictedTitle:
            'modules.notification.alarmRuleAddEdit.labels.notAllowedToSeeDefaultEmailRecipients' | translate
        }"
        class="is-disabled-by-style"
      />
    </osp-form-field>
  </div>

  <div class="flex align-items-start gap-2 pt-3">
    <osp-label class="align-items-start" [switchControl]="$any(form.controls[controlNames.DATA_EMAIL_TOGGLE])">
      <ng-container>
        {{ 'revolution.modules.notification.alarmRuleAddEdit.labels.emailToggle' | translate }}
      </ng-container>
      <ng-container additional-label>
        {{ 'revolution.modules.notification.alarmRuleAddEdit.expl.emailToggle' | translate }}
      </ng-container>
    </osp-label>
  </div>

  @if (emailToggleControl?.value) {
    <div class="grid grid-nogutter gap-2">
      <div class="flex flex-column flex-1 col-6">
        <osp-form-field>
          <osp-label>{{ 'modules.notification.alarmRuleAddEdit.labels.emailRecipients' | translate }}</osp-label>
          <osp-select
            [formControlName]="controlNames.DATA_EMAIL_RECIPIENTS"
            [options]="(userSuggestions$ | async) ?? []"
            (onFilter)="searchRecipientEmails($event.filter)"
            [selectedItemsConfiguration]="{
              title: 'modules.notification.alarmRuleAddEdit.labels.emailRecipients' | translate
            }"
          />
        </osp-form-field>
      </div>

      <div class="flex flex-column flex-1 col-6">
        <osp-form-field>
          <osp-label>{{ 'modules.notification.alarmRuleAddEdit.labels.emailRoles' | translate }}</osp-label>
          <osp-select
            [formControlName]="controlNames.DATA_ROLE_RECIPIENTS"
            [options]="(roleSuggestions$ | async) ?? []"
            [selectedItemsConfiguration]="{
              title: 'modules.notification.alarmRuleAddEdit.labels.emailRoles' | translate
            }"
          />
        </osp-form-field>
      </div>
    </div>
  }
  @if ($showIsFeedbackRequiredToggle()) {
    <div class="flex align-items-start gap-2 pt-3">
      <osp-label class="align-items-start" [switchControl]="$any(form.controls[controlNames.DATA_FEEDBACK_TOGGLE])">
        <ng-container>
          {{ 'modules.notification.alarmRuleAddEdit.labels.feedbackRequired' | translate }}
        </ng-container>
      </osp-label>
    </div>
  }
  @if ($showPreventDuplicateAlarmsToggle()) {
    <div class="flex align-items-start gap-2 pt-3">
      <osp-label
        class="align-items-start"
        [switchControl]="$any(form.controls[controlNames.DATA_PREVENT_DUPLICATE_OPEN_ALARMS_TOGGLE])"
      >
        <ng-container>
          {{ 'revolution.modules.notification.alarmRuleAddEdit.labels.preventDuplicateAlarmsToggle' | translate }}
        </ng-container>
        <ng-container additional-label>
          {{ 'revolution.modules.notification.alarmRuleAddEdit.expl.preventDuplicateAlarmsToggle' | translate }}
        </ng-container>
      </osp-label>
    </div>
  }
</div>
